import { Paragraph } from '@audio-network/componentlibrary'

const ToastBody = ({
	children,
	...props
}: {
	children: React.ReactNode
}): JSX.Element => {
	return <Paragraph {...props}>{children}</Paragraph>
}

export default ToastBody
